export default "__VITE_ASSET__DShCIU7P__"